<template>
  <div>
    <el-button class="newAdd" @click="openDialog" size="mini"
      >修改返佣比例</el-button
    >
    <el-dialog
      title="修改返佣比例"
      :visible.sync="moveDialogVisible"
      width="40%"
      center
      :close-on-click-modal="!settingsBusy"
      :close-on-press-escape="!settingsBusy"
      :show-close="!settingsBusy"
      @close="clear"
    >
      <el-form :model="form" :rules="rules" ref="form" :disabled="settingsBusy">
        <el-form-item label="UID" :label-width="formLabelWidth" prop="userId">
          <div class="search">
            <el-input
              v-model="form.userId"
              class="searchIpt"
              autocomplete="off"
            ></el-input>
          </div>
        </el-form-item>

        <el-form-item
          label="合约返佣比例"
          :label-width="formLabelWidth"
          prop="rate"
        >
          <el-input
            v-model="form.rate"
            class="searchIpt"
            maxlength="3"
            autocomplete="off"
            @input="(val) => handleIntegerInput('rate', val)"
          >
            <template slot="append">%</template></el-input
          >
        </el-form-item>
        <el-form-item
          label="现货返佣比例"
          :label-width="formLabelWidth"
          prop="spotRate"
          v-if="spotState === 'legacy'"
        >
          <el-input
            v-model="form.spotRate"
            class="searchIpt"
            maxlength="3"
            autocomplete="off"
            @input="(val) => handleIntegerInput('spotRate', val)"
          >
            <template slot="append">%</template></el-input>
        </el-form-item>
        <!-- <el-form-item label="otc返佣比例" :label-width="formLabelWidth" prop="otcRate" >
        <el-input v-model="form.otcRate" class="searchIpt" autocomplete="off">
          <template slot="append">%</template></el-input>
    </el-form-item> -->
        <SpotRebateSettings v-if="moveDialogVisible" ref="spotSettings" :user-id="form.userId"
          @state="spotState = $event" @busy="settingsBusy = $event" @refresh="$emit('refresh')"
          @requery="clear(); $emit('refresh')" />
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="handleRate">添加</el-button>
            <el-button size="small"  @click="clear">重置</el-button>
          </span> -->
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="settingsBusy" @click="clear">取 消</el-button>
        <el-button type="primary" :loading="settingsBusy" :disabled="settingsBusy || !['ready', 'legacy'].includes(spotState)" @click="handleRate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SpotRebateSettings from "@/components/spot-rebate/Settings";
import { mapActions } from "vuex";

const validateInteger = (requiredMessage) => (rule, value, callback) => {
  if (value === "" || value === null || value === undefined) {
    if (requiredMessage) {
      callback(new Error(requiredMessage));
    } else {
      callback();
    }
    return;
  }
  if (!/^\d+$/.test(String(value).trim())) {
    callback(new Error("只能输入整数"));
    return;
  }
  callback();
};

export default {
  components: { SpotRebateSettings },
  data() {
    return {
      spotState: 'loading',
      settingsBusy: false,
      moveDialogVisible: false,
      form: {
        rate: "",
        userId: "",
        spotRate: "",
      },
      formLabelWidth: "140px",
      rules: {
        userId: [{ required: true, message: "请输入UID", trigger: "blur" }],
        rate: [
          {
            required: true,
            validator: validateInteger("请输入比例"),
            trigger: "blur",
          },
        ],
        spotRate: [{ validator: validateInteger(), trigger: "blur" }],
        otcRate: [
          { required: true, message: "请输入otc返佣比例", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    ...mapActions("partnerList", ["upgradeRate"]),
    openDialog() {
      this.spotState = 'loading';
      this.moveDialogVisible = true;
    },
    handleIntegerInput(field, val) {
      this.form[field] = String(val).replace(/\D/g, "");
    },
    handleRate() {
      if (this.settingsBusy || !['ready', 'legacy'].includes(this.spotState)) return;
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        if (this.spotState === 'ready') {
          const saved = await this.$refs.spotSettings.saveWithContract(
            { userId: this.form.userId, rate: this.form.rate }, data => this.upgradeRate(data));
          if (saved) this.clear();
          return;
        }
        this.upgradeRate(this.form).then((res) => {
          if (res.code == 0) {
            this.$message.success("修改成功");
            this.$emit("refresh");
            this.clear();
          } else {
            this.$message.error(res.msg || "修改失败");
            this.clear();
          }
        });
      });
    },
    clearFiled() {
      this.$refs["form"].resetFields();
    },
    clear() {
      if (this.settingsBusy) return;
      this.moveDialogVisible = false;
      if (this.$refs.form) this.$refs.form.resetFields();
    },
  },
};
</script>

<style lang="less" src="../../../../styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;
  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }
  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    .ipt {
      width: 90%;
    }
  }
}
.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
